import React from 'react';
import { Link } from 'react-router-dom';

type AdminContext = 'admin' | 'chatbot' | 'agents';

type AdminContextSwitcherProps = {
  active?: AdminContext;
  className?: string;
};

const linkClass = (active: boolean) =>
  active
    ? 'px-3 py-2 rounded-md text-sm font-medium bg-blue-800'
    : 'px-3 py-2 rounded-md text-sm font-medium hover:bg-blue-700 bg-blue-800/60';

export const AdminContextSwitcher: React.FC<AdminContextSwitcherProps> = ({
  active,
  className = '',
}) => (
  <div className={`hidden md:flex md:items-center gap-1 ${className}`}>
    <Link to="/admin/control-panel" className={linkClass(active === 'admin')}>
      Administração
    </Link>
    <Link to="/agent-platform" className={linkClass(active === 'agents')}>
      Agentes
    </Link>
  </div>
);
